import React, { useState, useEffect } from 'react';
import { Card, Accordion, Form, Row, Col, Button, Spinner, Table, Modal } from 'react-bootstrap'; // Tabs e Tab removidos, Accordion e Modal adicionados
import { Line } from 'react-chartjs-2';
import axios from 'axios';
import { useAlertModal } from '../../AlertModalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faCheck, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const RelatoriosFaturamentoTab = ({
  currentEntidade, // Necessário para chamadas API
  formatCurrency, // Função de formatação
  isActive, // Propriedade para indicar se a aba está ativa
}) => {
  // activeFaturamentoTabKey não é mais necessário com Accordion
  const { showAlertModal } = useAlertModal();
  // Estados para o relatório "Faturamento Detalhado por Serviço"
  const [faturamentoPorServicoData, setFaturamentoPorServicoData] = useState([]);
  const [isLoadingFaturamentoServico, setIsLoadingFaturamentoServico] = useState(false);
  const [filtroDataInicioServico, setFiltroDataInicioServico] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0]
  );
  const [filtroDataFimServico, setFiltroDataFimServico] = useState(
    new Date().toISOString().split('T')[0]
  );

  // Estados para "Faturamento por Paciente"
  const [faturamentoPorPacienteData, setFaturamentoPorPacienteData] = useState([]);
  const [isLoadingFaturamentoPaciente, setIsLoadingFaturamentoPaciente] = useState(false);
  const [filtroDataInicioPaciente, setFiltroDataInicioPaciente] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0]
  );
  const [filtroDataFimPaciente, setFiltroDataFimPaciente] = useState(
    new Date().toISOString().split('T')[0]
  );

  // Estados para "Faturamento por Período"
  const [faturamentoPorPeriodoData, setFaturamentoPorPeriodoData] = useState({ labels: [], datasets: [] });
  const [isLoadingFaturamentoPeriodo, setIsLoadingFaturamentoPeriodo] = useState(false);
  const [filtroTipoPeriodo, setFiltroTipoPeriodo] = useState('mensal'); // diario, semanal, mensal, anual
  const [filtroAnoPeriodo, setFiltroAnoPeriodo] = useState(new Date().getFullYear());
  const [filtroDataInicioPeriodo, setFiltroDataInicioPeriodo] = useState(new Date(new Date().setDate(new Date().getDate() - 29)).toISOString().split('T')[0]);
  const [filtroDataFimPeriodo, setFiltroDataFimPeriodo] = useState(new Date().toISOString().split('T')[0]);

  // Estados para o modal de detalhes do paciente
  const [showDetalhesModal, setShowDetalhesModal] = useState(false);
  const [selectedPacienteDetalhes, setSelectedPacienteDetalhes] = useState(null);
  const [detalhesPacienteData, setDetalhesPacienteData] = useState([]);
  const [isLoadingDetalhesPaciente, setIsLoadingDetalhesPaciente] = useState(false);

  // --- NOVOS ESTADOS PARA GERENCIAR COMISSÃO ---
  const [allFuncionarios, setAllFuncionarios] = useState([]);
  const [allServices, setAllServices] = useState([]); // Para verificar elegibilidade
  const [editingCommission, setEditingCommission] = useState({ pagamentoId: null, servicoId: null });
  const [selectedProfessionalForCommission, setSelectedProfessionalForCommission] = useState('');
  const [commissionPercentage, setCommissionPercentage] = useState('');
  const [isAddingCommission, setIsAddingCommission] = useState(false);

  // Busca dados auxiliares (serviços e funcionários)
  useEffect(() => {
    if (currentEntidade?.id) {
        // Busca serviços para saber quais têm comissão configurada
        axios.get(`/api/servicos?entidade_id=${currentEntidade.id}`)
            .then(res => setAllServices(res.data.servicos || []))
            .catch(console.error);
            
        // Busca funcionários comissionáveis (dados básicos)
        axios.get(`/api/relatorios/funcionarios-comissionaveis`, { params: { entidade_id: currentEntidade.id } })
            .then(res => setAllFuncionarios(res.data.funcionarios || []))
            .catch(console.error);
    }
  }, [currentEntidade]);

  const handleStartAddCommission = (pagamentoId, servicoId) => {
      setEditingCommission({ pagamentoId, servicoId });
      setSelectedProfessionalForCommission('');
      
      const serviceDef = allServices.find(s => s.id === servicoId);
      if (serviceDef) {
          setCommissionPercentage(serviceDef.percentual_comissao || 0);
      } else {
          setCommissionPercentage(0);
      }
  };

  const handleCancelAddCommission = () => {
      setEditingCommission({ pagamentoId: null, servicoId: null });
      setSelectedProfessionalForCommission('');
      setCommissionPercentage('');
  };

  const handleSaveCommission = async (pagamentoId, servicoId) => {
      if (!selectedProfessionalForCommission) {
           showAlertModal('Atenção', 'Selecione um profissional.', 'warning');
           return;
      }
      
      setIsAddingCommission(true);
      try {
          await axios.post(`/api/pagamentos/${pagamentoId}/servicos/${servicoId}/comissao`, {
              funcionario_id: selectedProfessionalForCommission,
              percentual_comissao: commissionPercentage
          });
          
          showAlertModal('Sucesso', 'Comissão atribuída com sucesso!', 'success');
          handleCancelAddCommission();
          if (selectedPacienteDetalhes) fetchDetalhesPaciente(selectedPacienteDetalhes.paciente_id); // Atualiza a lista
      } catch (error) {
          console.error("Erro ao adicionar comissão:", error);
          showAlertModal('Erro', `Falha ao adicionar comissão: ${error.response?.data?.message || error.message}`, 'danger');
      } finally {
          setIsAddingCommission(false);
      }
  };

  // Funções de busca (mantidas aqui, pois gerenciam o estado local desta aba)
  const fetchFaturamentoPorServico = async () => {
    if (!filtroDataInicioServico || !filtroDataFimServico || !currentEntidade) return;
    setIsLoadingFaturamentoServico(true);
    try {
      const response = await axios.get(`/api/relatorios/faturamento/por-servico`, {
        params: { entidade_id: currentEntidade.id, data_inicio: filtroDataInicioServico, data_fim: filtroDataFimServico }
      });
      setFaturamentoPorServicoData(response.data.dados || []);
    } catch (error) { console.error("Erro ao buscar faturamento por serviço:", error); setFaturamentoPorServicoData([]); }
    finally { setIsLoadingFaturamentoServico(false); }
  };

  const fetchFaturamentoPorPaciente = async () => {
    if (!filtroDataInicioPaciente || !filtroDataFimPaciente || !currentEntidade) return;
    setIsLoadingFaturamentoPaciente(true);
    try {
      const response = await axios.get(`/api/relatorios/faturamento/por-paciente`, {
        params: { entidade_id: currentEntidade.id, data_inicio: filtroDataInicioPaciente, data_fim: filtroDataFimPaciente }
      });
      setFaturamentoPorPacienteData(response.data.dados || []);
    } catch (error) { console.error("Erro ao buscar faturamento por paciente:", error); setFaturamentoPorPacienteData([]); }
    finally { setIsLoadingFaturamentoPaciente(false); }
  };

  const fetchFaturamentoPorPeriodo = async () => {
    if (!currentEntidade) return;
    setIsLoadingFaturamentoPeriodo(true);
    const params = { entidade_id: currentEntidade.id, tipo_periodo: filtroTipoPeriodo };
    if (filtroTipoPeriodo === 'mensal' || filtroTipoPeriodo === 'anual') { params.ano = filtroAnoPeriodo; }
    else if (filtroTipoPeriodo === 'diario' || filtroTipoPeriodo === 'semanal') { params.data_inicio = filtroDataInicioPeriodo; params.data_fim = filtroDataFimPeriodo; }
    try {
      const response = await axios.get(`/api/relatorios/faturamento/por-periodo`, { params });
      setFaturamentoPorPeriodoData({
        labels: response.data.labels || [],
        datasets: [{ label: `Faturamento ${filtroTipoPeriodo.charAt(0).toUpperCase() + filtroTipoPeriodo.slice(1)} (R$)`, data: response.data.data || [], borderColor: 'rgb(75, 192, 192)', backgroundColor: 'rgba(75, 192, 192, 0.5)', }],
      });
    } catch (error) { console.error("Erro ao buscar faturamento por período:", error); setFaturamentoPorPeriodoData({ labels: [], datasets: [] }); }
    finally { setIsLoadingFaturamentoPeriodo(false); }
  };

  // NOVO: Função para buscar os detalhes de faturamento de um paciente específico
  const fetchDetalhesPaciente = async (pacienteId) => {
    if (!pacienteId || !currentEntidade) return;
    setIsLoadingDetalhesPaciente(true);
    try {
      const response = await axios.get(`/api/relatorios/faturamento/paciente-detalhes`, {
        params: {
          entidade_id: currentEntidade.id,
          paciente_id: pacienteId,
          data_inicio: filtroDataInicioPaciente, // Usa os mesmos filtros da tabela principal
          data_fim: filtroDataFimPaciente
        }
      });
      setDetalhesPacienteData(response.data.dados || []);
    } catch (error) {
      console.error("Erro ao buscar detalhes de faturamento do paciente:", error);
      setDetalhesPacienteData([]);
    } finally {
      setIsLoadingDetalhesPaciente(false);
    }
  };

  // Efeito para carregar dados quando a aba de Faturamento é ativada ou filtros mudam
  useEffect(() => {
    if (isActive && currentEntidade) { // Só busca se a aba estiver ativa E a entidade carregada
      fetchFaturamentoPorServico();
      fetchFaturamentoPorPaciente();
      fetchFaturamentoPorPeriodo();
    }
  }, [isActive, currentEntidade, filtroDataInicioServico, filtroDataFimServico, filtroDataInicioPaciente, filtroDataFimPaciente, filtroTipoPeriodo, filtroAnoPeriodo, filtroDataInicioPeriodo, filtroDataFimPeriodo]); // Adiciona isActive às dependências

  // NOVO: Efeito para buscar os detalhes quando um paciente é selecionado
  useEffect(() => {
    if (selectedPacienteDetalhes) {
      fetchDetalhesPaciente(selectedPacienteDetalhes.paciente_id);
    }
  }, [selectedPacienteDetalhes]);

  const handleShowDetalhes = (paciente) => {
    setSelectedPacienteDetalhes(paciente);
    setShowDetalhesModal(true);
  };
  return (
    // Usar defaultActiveKey="0" para abrir o primeiro item por padrão, ou remova para todos fechados.
    // Ou use alwaysOpen para permitir que múltiplos itens fiquem abertos.
    <Accordion defaultActiveKey="0" className="mb-3 custom-accordion-financeiro">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Faturamento Detalhado por Serviço</Accordion.Header>
        <Accordion.Body>
          <Card className="mb-0"> {/* mb-0 para remover margem inferior do card dentro do accordion */}
            {/* O Card.Header original pode ser removido ou mantido se desejar um subtítulo */}
            {/* <Card.Header><h4>Faturamento Detalhado por Serviço</h4></Card.Header> */}
            <Card.Body>
              <Form className="mb-3">
                <Row className="align-items-end">
                  <Col md={4}>
                    <Form.Group controlId="filtroDataInicioServicoTab">
                      <Form.Label>Data Início</Form.Label>
                      <Form.Control type="date" value={filtroDataInicioServico} onChange={(e) => setFiltroDataInicioServico(e.target.value)} />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group controlId="filtroDataFimServicoTab">
                      <Form.Label>Data Fim</Form.Label>
                      <Form.Control type="date" value={filtroDataFimServico} onChange={(e) => setFiltroDataFimServico(e.target.value)} />
                    </Form.Group>
                  </Col>
                  <Col md={2}><Button variant="primary" onClick={fetchFaturamentoPorServico} disabled={isLoadingFaturamentoServico}>{isLoadingFaturamentoServico ? <Spinner as="span" animation="border" size="sm" /> : 'Filtrar'}</Button></Col>
                  <Col md={2} className="text-end"><Button variant="outline-secondary" size="sm" onClick={() => alert('Exportar CSV não implementado')}>Exportar CSV</Button></Col>
                </Row>
              </Form>
              {isLoadingFaturamentoServico ? <div className="text-center"><Spinner animation="border" /></div> : (
                faturamentoPorServicoData.length > 0 ? (
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th>Nome do Serviço</th>
                        <th className="d-none d-md-table-cell">Qtd. Realizado</th> {/* Oculta em xs e sm */}
                        <th className="d-none d-md-table-cell">Valor Unit. Médio</th> {/* Oculta em xs e sm */}
                        <th>Faturamento Total</th>
                        <th>% do Fat. Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {faturamentoPorServicoData.map((item) => (<tr key={item.id || item.nome_servico}><td>{item.nome_servico}</td><td className="d-none d-md-table-cell">{item.quantidade_realizado}</td><td className="d-none d-md-table-cell">{formatCurrency(item.valor_unitario_medio)}</td><td>{formatCurrency(item.faturamento_total_servico)}</td><td>{item.percentual_faturamento_total.toFixed(2)}%</td></tr>))}
                    </tbody>
                  </Table>
                ) : <p>Nenhum dado de faturamento por serviço encontrado para o período selecionado.</p>
              )}
            </Card.Body>
          </Card>
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="1">
        <Accordion.Header>Faturamento por Paciente</Accordion.Header>
        <Accordion.Body>
          <Card className="mb-0">
            {/* <Card.Header><h4>Faturamento por Paciente</h4></Card.Header> */}
            <Card.Body>
              <Form className="mb-3">
                <Row className="align-items-end">
                  <Col md={4}>
                    <Form.Group controlId="filtroDataInicioPacienteTab">
                      <Form.Label>Data Início</Form.Label>
                      <Form.Control type="date" value={filtroDataInicioPaciente} onChange={(e) => setFiltroDataInicioPaciente(e.target.value)} />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group controlId="filtroDataFimPacienteTab">
                      <Form.Label>Data Fim</Form.Label>
                      <Form.Control type="date" value={filtroDataFimPaciente} onChange={(e) => setFiltroDataFimPaciente(e.target.value)} />
                    </Form.Group>
                  </Col>
                  <Col md={2}><Button variant="primary" onClick={fetchFaturamentoPorPaciente} disabled={isLoadingFaturamentoPaciente}>{isLoadingFaturamentoPaciente ? <Spinner as="span" animation="border" size="sm" /> : 'Filtrar'}</Button></Col>
                  <Col md={2} className="text-end"><Button variant="outline-secondary" size="sm" onClick={() => alert('Exportar CSV não implementado')}>Exportar CSV</Button></Col>
                </Row>
              </Form>
              {isLoadingFaturamentoPaciente ? <div className="text-center"><Spinner animation="border" /></div> : (
                faturamentoPorPacienteData.length > 0 ? (
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th>Nome do Paciente</th>
                        <th>Nº Serviços Realizados</th>
                        <th>Faturamento Total</th>
                        <th>Data do Último Serviço</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {faturamentoPorPacienteData.map((item) => (<tr key={item.id || item.nome_paciente}>
                        <td>{item.nome_paciente}</td>
                        <td>{item.numero_servicos_realizados}</td>
                        <td>{formatCurrency(item.faturamento_total_paciente)}</td>
                        <td>{new Date(item.data_ultimo_servico + 'T00:00:00').toLocaleDateString('pt-BR')}</td>
                        <td><Button variant="outline-info" size="sm" onClick={() => handleShowDetalhes(item)}>Detalhes</Button></td>
                      </tr>))}
                    </tbody>
                  </Table>
                ) : <p>Nenhum dado de faturamento por paciente encontrado para o período selecionado.</p>
              )}
            </Card.Body>
          </Card>
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="2">
        <Accordion.Header>Faturamento por Período</Accordion.Header>
        <Accordion.Body>
          <Card className="mb-0">
            {/* <Card.Header><h4>Faturamento por Período</h4></Card.Header> */}
            <Card.Body>
              <Form className="mb-3">
                <Row className="align-items-end">
                  <Col md={4}>
                    <Form.Group controlId="filtroTipoPeriodoTab">
                      <Form.Label>Agrupar por:</Form.Label>
                      <Form.Select value={filtroTipoPeriodo} onChange={(e) => setFiltroTipoPeriodo(e.target.value)}>
                        <option value="diario">Diário (Últimos 30 dias)</option>
                        <option value="semanal">Semanal (Últimas 12 semanas)</option>
                        <option value="mensal">Mensal (Ano Corrente)</option>
                        <option value="anual">Anual</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  {filtroTipoPeriodo === 'anual' && (
                    <Col md={3}>
                      <Form.Group controlId="filtroAnoPeriodoTab">
                        <Form.Label>Ano:</Form.Label>
                        <Form.Control type="number" value={filtroAnoPeriodo} onChange={(e) => setFiltroAnoPeriodo(parseInt(e.target.value))} />
                      </Form.Group>
                    </Col>
                  )}
                  {(filtroTipoPeriodo === 'diario' || filtroTipoPeriodo === 'semanal') && (
                    <>
                      <Col md={3}>
                        <Form.Group controlId="filtroDataInicioPeriodoTab">
                          <Form.Label>Data Início</Form.Label>
                          <Form.Control type="date" value={filtroDataInicioPeriodo} onChange={(e) => setFiltroDataInicioPeriodo(e.target.value)} />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group controlId="filtroDataFimPeriodoTab">
                          <Form.Label>Data Fim</Form.Label>
                          <Form.Control type="date" value={filtroDataFimPeriodo} onChange={(e) => setFiltroDataFimPeriodo(e.target.value)} />
                        </Form.Group>
                      </Col>
                    </>
                  )}
                  {filtroTipoPeriodo === 'mensal' && ( // Show Ano filter for Mensal
                    <Col md={3}>
                        <Form.Group controlId="filtroAnoPeriodoMensalTab">
                          <Form.Label>Ano:</Form.Label>
                          <Form.Control type="number" value={filtroAnoPeriodo} onChange={(e) => setFiltroAnoPeriodo(parseInt(e.target.value))} />
                        </Form.Group>
                    </Col>
                  )}
                  <Col md={2}><Button variant="primary" onClick={fetchFaturamentoPorPeriodo} disabled={isLoadingFaturamentoPeriodo}>{isLoadingFaturamentoPeriodo ? <Spinner as="span" animation="border" size="sm" /> : 'Gerar'}</Button></Col>
                </Row>
              </Form>
              {isLoadingFaturamentoPeriodo ? <div className="text-center"><Spinner animation="border" /></div> : (
                faturamentoPorPeriodoData.labels.length > 0 ? <Line data={faturamentoPorPeriodoData} /> : <p>Selecione os filtros para gerar o gráfico.</p>
              )}
            </Card.Body>
          </Card>
          <hr/>
          <h4>Comparativo de Faturamento entre Períodos</h4>
          <p><i>(Conteúdo a ser implementado: Comparativos com variação percentual)</i></p>
        </Accordion.Body>
      </Accordion.Item>

      {/* NOVO: Modal para exibir detalhes do faturamento do paciente */}
      <Modal show={showDetalhesModal} onHide={() => setShowDetalhesModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Detalhes de Faturamento: {selectedPacienteDetalhes?.nome_paciente}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoadingDetalhesPaciente ? (
            <div className="text-center"><Spinner animation="border" /></div>
          ) : (
            detalhesPacienteData.length > 0 ? (
              <Table striped bordered hover responsive size="sm">
                <thead>
                  <tr>
                    <th>Data do Serviço</th>
                    <th>Nome do Serviço</th>
                    <th>Valor Pago</th>
                    <th>% Comissão</th>
                    <th>Recebido por</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {detalhesPacienteData.map((detalhe, index) => {
                    // Verifica se o serviço é passível de comissão
                    const serviceDef = allServices.find(s => s.id === detalhe.servico_id || s.nome === detalhe.nome_servico);
                    const isCommissionable = serviceDef && parseFloat(serviceDef.percentual_comissao) > 0;
                    const hasCommission = !!detalhe.nome_comissionado;
                    const percentualExibido = detalhe.percentual_comissao_pago ? detalhe.percentual_comissao_pago : detalhe.percentual_comissao;

                    return (
                    <tr key={index} style={{ verticalAlign: 'middle' }}>
                      <td>{new Date(detalhe.data_servico + 'T00:00:00').toLocaleDateString('pt-BR')}</td>
                      <td>{detalhe.nome_servico}</td>
                      <td>{formatCurrency(detalhe.valor_pago)}</td>
                      <td>{percentualExibido ? `${parseFloat(percentualExibido).toFixed(2)}%` : (isCommissionable ? <span className="text-muted small">{parseFloat(serviceDef.percentual_comissao).toFixed(2)}% (Elegível)</span> : '-')}</td>
                      <td>{detalhe.nome_comissionado || '-'}</td>
                      <td>
                        {!hasCommission && isCommissionable && (
                            editingCommission.pagamentoId === detalhe.pagamento_id && editingCommission.servicoId === detalhe.servico_id ? (
                                <div className="d-flex align-items-center gap-1">
                                    <Form.Select size="sm" value={selectedProfessionalForCommission} onChange={(e) => setSelectedProfessionalForCommission(e.target.value)} style={{ maxWidth: '130px' }}>
                                        <option value="">Selecione...</option>
                                        {allFuncionarios.map(f => <option key={f.id} value={f.id}>{f.nome}</option>)}
                                    </Form.Select>
                                    <Form.Control 
                                        type="number" 
                                        size="sm" 
                                        style={{ maxWidth: '60px' }} 
                                        value={commissionPercentage} 
                                        onChange={(e) => setCommissionPercentage(e.target.value)} 
                                        placeholder="%"
                                    />
                                    <Button variant="success" size="sm" onClick={() => handleSaveCommission(detalhe.pagamento_id, detalhe.servico_id)} disabled={isAddingCommission}><FontAwesomeIcon icon={faCheck} /></Button>
                                    <Button variant="secondary" size="sm" onClick={handleCancelAddCommission} disabled={isAddingCommission}><FontAwesomeIcon icon={faArrowLeft} /></Button>
                                </div>
                            ) : (
                                <Button variant="outline-primary" size="sm" onClick={() => handleStartAddCommission(detalhe.pagamento_id, detalhe.servico_id)} title="Adicionar Comissão"><FontAwesomeIcon icon={faPlus} /></Button>
                            )
                        )}
                      </td>
                    </tr>
                  )})}
                </tbody>
              </Table>
            ) : <p>Nenhum detalhe encontrado para este paciente no período selecionado.</p>
          )}
        </Modal.Body>
        <Modal.Footer><Button variant="secondary" onClick={() => setShowDetalhesModal(false)}>Fechar</Button></Modal.Footer>
      </Modal>
    </Accordion>
  );
};

export default RelatoriosFaturamentoTab;